import { HttpError, IResourceComponentsProps } from "@refinedev/core";
import { Create, useForm } from "@refinedev/antd";
import { Form, Input, Select, Spin } from "antd";
import { error } from "console";

export const AdminCreate: React.FC<IResourceComponentsProps> = () => {
    const { formProps, saveButtonProps, formLoading } = useForm<
        any,
        HttpError,
        any
    >({
        resource: "admin",
        onMutationSuccess: (data) => {
            // console.log("Data:", data)
            return {
                message: data?.data.message,
                type: "success",
            };
        },
        onMutationError: (error) => {
            // console.log("ERROR:", error)
            return {
                message: error?.message,
                type: "error"
            };
        },  
        action: "create",
    })

    return (
        <Create saveButtonProps={{ ...saveButtonProps, loading: formLoading }}>
            <Form {...formProps} layout="vertical">
                <Form.Item
                    label={"Full name"}
                    name={["fullName"]}
                    rules={[
                        {
                            required: true,
                        },
                    ]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    label={"Email"}
                    name={["email"]}
                    rules={[
                        {
                            required: true,
                            pattern: /^([A-Z0-9_+-]+\.?)*[A-Z0-9_+-]@([A-Z0-9][A-Z0-9-]*\.)+[A-Z]{2,}$/i,
                            message: "Please enter a valid email address",
                        },
                    ]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    label={"Role"}
                    name={["role"]}
                    initialValue="ADMIN"
                    rules={[{ required: true }]}
                >
                    <Select>
                        <Select.Option value="ADMIN">Admin</Select.Option>
                        <Select.Option value="EMPLOYEE">Employee</Select.Option>
                    </Select>
                </Form.Item>
            </Form>
        </Create>
    )
}